import React, {PureComponent} from "react";
import {GameEntity} from "../data/entities/GameEntity";
import uplayTagImg from "../resources/img/logo_tag.svg";
import uiBtnPlayActive from "../resources/btn/BTN_Play_Active.svg";
import uiBtnPlayNotActive from "../resources/btn/BTN_Play_NotActive.svg";
import {FormattedMessage, injectIntl, WrappedComponentProps} from "react-intl";
import uiBtnPlay from "../resources/btn/BTN_Play.svg";
import {ScaleLoader} from "react-spinners";
import classNames from "classnames";

interface Props {
    index: number;
    game: GameEntity;
    handleGameAction: Function;
    userOwnership: Function;
}

class GameItem extends PureComponent<Props & WrappedComponentProps> {
    render(): JSX.Element {

        const {game} = this.props;

        const userOwnership: boolean = this.props.userOwnership(game);

        const classes = classNames({
            game: true,
            loading: game.loading,
            activated: userOwnership
        });

        return (
            <div className={classes} onClick={() => this.props.handleGameAction(this.props.game, this.props.index)}>
                <img className="cover" src={this.props.game.image} alt={this.props.game.name}/>
                <div className="game-details">
                    <img className="uplaypluslogo" src={uplayTagImg} alt="Ubisoft+"/>
                    <div className="game-title">
                        <h3>{this.props.game.name}</h3>
                    </div>
                    {
                        !userOwnership &&
                        <img className="material-icons" src={uiBtnPlayNotActive} alt={this.props.intl.formatMessage({id: "action.launch_game"})} />
                    }
                    {
                        userOwnership &&
                        <img className="material-icons" src={uiBtnPlayActive} alt={this.props.intl.formatMessage({id: "action.launch_game"})} />
                    }
                </div>
                <div className="action">
                    <span><FormattedMessage id="action.launch_game"/></span>
                    <img className="material-icons" src={uiBtnPlay} alt={this.props.intl.formatMessage({id: "action.launch_game"})} />
                </div>

                {
                    this.props.game.loading &&
                    <div className="game-loader">
                        <ScaleLoader color={'#fff'}/>
                    </div>
                }
            </div>
        );
    }
}

export default injectIntl(GameItem);